const constant = {
    ZONES :{
        FRONT: "F",
        MIDDLE: "M",
        REAR: "R",
        TAIL: "T",        
        NOFMRT:"NOFMRT"
    },
    ZONES_LABEL:{
        FRONT: "Front",
        MIDDLE: "Middle",
        REAR: "Rear",
        TAIL: "Tail",        
        NOFMRT:"NOFMRT"
    },
    PRO_TYPE:{
        MISSED: "Missed",
        EXTRA: "Extra",
        MATCHED: "Matched"
    },
    BILL_TYPE:{
        PLANNED: "Planned Bills",
        ACTUAL: "Actual Bills"
    },
    ROUTE_TYPE:{
        PLANNED: "OPTIMIZED",
        ACTUAL: "GATEOUT"
    }
}

export default constant;